<template>
  <modal
    :nextRoute="{ name: 'menuIndex', params: { userSlug: user.slug } }"
    :showCloseButton="true"
  >
    <span
      slot="heading"
      class="p-3"
    > Add Menu Item </span>
    <span
      slot="description"
      class="p-3"
    > Add items to your menu </span>
    <form
      slot="content"
      class="mt-3 p-3"
      v-on:submit.prevent="onSubmit"
    >
      <div v-if="!processing">
        <label>Name</label>
        <div class="form-group">
          <input
            placeholder="Name"
            v-model="name"
            type="text"
            class="form-control"
            v-bind:class="{ 'is-invalid': errors.name }"
            required
          />
          <small
            v-if="errors.name"
            class="text-danger"
          >{{
            errors.name
          }}</small>
        </div>
        <label>Category</label>
        <div class="form-group">
          <select
            v-model="category"
            class="form-control"
            v-bind:class="{ 'is-invalid': errors.category }"
          >
            <option value="null">Category</option>
            <option
              v-for="(category,index) in rawMenu.categories"
              :key="index"
              v-bind:value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
          <small
            v-if="errors.category"
            class="text-danger"
          >
            Please select a category
          </small>
        </div>
        <hr />
        <label>Description</label>
        <div class="form-group">
          <textarea
            v-model="description"
            class="form-control"
            v-bind:class="{ 'is-invalid': errors.description }"
          ></textarea>
          <small
            v-if="errors.description"
            class="text-danger"
          >{{
            errors.description
          }}</small>
        </div>
        <h4 class="mt-3 py-2 d-block styled-border h4 border-style-0 border-position-1 ">
          Prices
        </h4>
        <div class="form-group p-3 bg-light rounded border shadow-sm">
          <input
            placeholder="Add a price"
            v-model="price"
            type="number"
            step="1"
            min="0"
            class="form-control form-control-sm mb-2"
          />

          <input
            v-if="price"
            placeholder="Price label (optional) e.g S, M or  L"
            v-model="priceLabel"
            type="text"
            maxlength="128"
            class="form-control form-control-sm mb-2 animate__animated animate__fadeIn"
          />

          <a
            v-if="price"
            href="#"
            class="d-inline-block color-1 small font-weight-bold animate__animated animate__fadeIn"
            v-on:click.prevent="addPrice()"
          >
            Add Price
          </a>
        </div>
        <div class="form-group">
          <draggable v-model="prices">
            <div
              class="py-3 px-1 border-bottom bg-white"
              v-for="(price,index) in prices"
              :key="index"
            >
              <div class="d-flex justify-content-between">
                <div>
                  <span class="text-muted">{{ price.label }}</span>
                  <span class="font-weight-bold">{{ rawMenu.user.currency.symbol
                    }}{{ price.amount | centsToDollars }}</span>
                </div>

                <div class="text-right">
                  <a
                    href=""
                    class="ml-3 small color-1"
                    v-on:click.prevent="removePrice(price)"
                  >Remove</a>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <div v-if="rawMenu.user.country.id==226 && rawMenu.user.stripe_charges_enabled">
          <h4
            class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
            v-on:click="taxRatesAccordionIsOpen=!taxRatesAccordionIsOpen"
            :class="{open: taxRatesAccordionIsOpen}"
          >
            <span>Tax rates</span> <i class="fal fa-chevron-down animated-chevron "></i>
          </h4>
          <div
            v-if="taxRatesAccordionIsOpen"
            class="form-group animate__animated animate__fadeIn"
          >
            <div class="form-group">
              <select
                class="form-control"
                v-model="taxProductType"
              >
                <option
                  v-for="(option,oa) in taxAppicationOptions"
                  :value="option.value"
                  :key="'optapp-'+oa"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <h4 class="mt-3 py-2 d-block styled-border h4 border-style-0 border-position-1 ">
          Picture
        </h4>
        <div class="form-group">
          <input
            ref="image"
            type="file"
            @change="imageChanged"
            class="form-control-file"
            v-bind:class="{ 'is-invalid': errors.image }"
          />
          <div>
            <small
              v-if="errors.image"
              class="form-text ft-3 text-danger"
            >Images should be less that 10mb and a valid image, .jpg or
              .png</small>
            <div
              class="mt-2"
              v-if="this.image"
            >
              <a
                v-if="image"
                v-on:click="
                  image = '';
                  $refs.image.value = '';
                "
                class="clr small"
              >Remove <i class="fa fa-times"></i></a>
            </div>
          </div>
        </div>
        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="additionalInfoAccordionIsOpen=!additionalInfoAccordionIsOpen"
          :class="{open: additionalInfoAccordionIsOpen}"
        >
          <span>Additional info</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>
        <div
          v-if="additionalInfoAccordionIsOpen"
          class="form-group animate__animated animate__fadeIn"
        >
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="soldout"
            ><span class="w-50">Sold out</span>
              <input
                v-model="isSoldOut"
                type="checkbox"
                id="soldout"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="takeout"
            > <span class="w-50">Available for pickup</span>
              <input
                v-model="isTakeOut"
                type="checkbox"
                id="takeout"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="special"
            ><span class="w-50">On Special</span>
              <input
                v-model="isSpecial"
                type="checkbox"
                id="special"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="newitem"
            ><span class="w-50">New item</span>
              <input
                v-model="isNew"
                type="checkbox"
                id="newitem"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="popularitem"
            ><span class="w-50">Popular item</span>
              <input
                v-model="isPopular"
                type="checkbox"
                id="popularitem"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
        </div>
        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="singleAddOnAccordionIsOpen=!singleAddOnAccordionIsOpen"
          :class="{open: singleAddOnAccordionIsOpen}"
        >
          <span>Single add-ons</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>

        <div
          v-if="singleAddOnAccordionIsOpen"
          class="form-group animate__animated animate__fadeIn"
        >
          <draggable v-model="options">
            <div
              class="py-3 px-1 border-bottom bg-white"
              v-for="(option,index) in options"
              :key="index"
            >
              <label class="container-label">

                <span class="text-muted w-50">{{ option.label }}</span> <span class="font-weight-bold">{{ rawMenu.user.currency.symbol }}{{ option.amount | centsToDollars}}</span>

                <input
                  v-model="option.selected"
                  type="checkbox"
                />
              </label>
            </div>
          </draggable>
          <div
            v-if="!options"
            class="text-info small text-center p-3 rounded border border-info d-flex align-items-center justify-content-center"
          >Add some add-ons to get started</div>
          <div>
            <a
              class="d-inline-block mt-3"
              :href="'/' + rawMenu.user.slug + '/menu/options'"
            >
              Add-on manager <i class="fal fa-arrow-right ml-2"></i>
            </a>
          </div>
        </div>
        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="groupedAddOnAccordionIsOpen=!groupedAddOnAccordionIsOpen"
          :class="{open: groupedAddOnAccordionIsOpen}"
        >
          <span>Grouped add-ons</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>
        <div
          v-if="groupedAddOnAccordionIsOpen"
          class="form-group animate__animated animate__fadeIn"
        >

          <div class="form-group p-3 bg-light rounded border shadow-sm">

            <label>Label</label>
            <input
              placeholder="Label e.g Choose a flavor"
              v-model="optionGroupLabel"
              type="text"
              maxlength="128"
              class="form-control"
            />

            <div class="form-check py-3 px-1 border-bottom">
              <label
                class="container-label"
                for="option_is_required"
              ><span class="w-75">Is required</span>
                <input
                  v-model="optionGroupIsRequired"
                  type="checkbox"
                  id="option_is_required"
                  true-value="1"
                  false-value="0"
                />
              </label>
            </div>
            <div class="form-check py-3 px-1 border-bottom">
              <label
                class="container-label"
                for="option_can_select_multiple"
              ><span class="w-75">Can select multiple</span>
                <input
                  v-model="optionGroupMultipleSelect"
                  type="checkbox"
                  id="option_can_select_multiple"
                  true-value="1"
                  false-value="0"
                />
              </label>
            </div>
            <div v-if="optionGroupMultipleSelect==1">
              <div class="form-check py-3 px-1 border-bottom">
                <label
                  class="container-label"
                  for="option_min_selected"
                ><span class="w-50">Min selections</span>
                  <input
                    v-model="optionGroupMinSelected"
                    type="checkbox"
                    id="option_min_selected"
                    true-value="1"
                    false-value="0"
                  /></label>
              </div>
              <input
                class="form-control form-control-sm mb-2"
                v-if="optionGroupMinSelected==1"
                placeholder="Min selected"
                v-model="optionGroupMinSelectedAmount"
                type="number"
                min="0"
                step="1"
              />

              <div class="form-check py-3 px-1 border-bottom">
                <label
                  class="container-label"
                  for="option_max_selected"
                ><span class="w-50">Max selections</span>
                  <input
                    v-model="optionGroupMaxSelected"
                    type="checkbox"
                    id="option_max_selected"
                    true-value="1"
                    false-value="0"
                  />
                </label>
              </div>
              <input
                class="form-control form-control-sm mb-2"
                v-if="optionGroupMaxSelected==1"
                placeholder="Max selected"
                v-model="optionGroupMaxSelectedAmount"
                type="number"
                min="0"
                step="1"
              />
            </div>
            <div class="my-4 bg-white p-3">
              <label class="d-block text-center">Select Add-ons in group</label>
              <hr>
              <div :class="{'items-container':groupOptions.length}">
                <draggable v-model="groupOptions">
                  <div
                    class="py-3 px-1 border-bottom"
                    v-for="(option,index) in groupOptions"
                    :key="index"
                  >
                    <label class="container-label">

                      <span class="text-muted w-50">{{ option.label }}</span> <span class="font-weight-bold">{{ rawMenu.user.currency.symbol }}{{ option.amount | centsToDollars}}</span>

                      <input
                        v-model="option.selected"
                        type="checkbox"
                      />

                    </label>
                  </div>
                </draggable>
              </div>
              <div
                v-if="!groupOptions.length"
                class="text-info small text-center p-3 rounded border border-info d-flex align-items-center justify-content-center"
              > Add some add-ons to get started</div>
              <div>
                <a
                  class="d-inline-block mt-3"
                  :href="'/' + rawMenu.user.slug + '/menu/options'"
                >
                  Add-on manager <i class="fal fa-arrow-right ml-2"></i>
                </a>
              </div>
            </div>

            <div
              v-if="optionGroupErrorMessage"
              class="text-danger small text-center p-3 rounded border border-danger mb-3 d-flex align-items-center justify-content-center"
            >{{ optionGroupErrorMessage }}</div>
            <a
              href="#"
              class="d-inline-block color-1 small font-weight-bold animate__animated animate__fadeIn"
              v-on:click.prevent="addOptionGroup()"
            >
              Add Group
            </a>
          </div>
          <div>
            <draggable v-model="optionGroups">
              <div
                class="py-3 px-1 my-3  bg-light rounded p-3 small"
                v-for="(group,i) in optionGroups"
                :key="i"
              >
                <div
                  class="text-muted small"
                  v-if="group.is_required==1"
                >Required*</div>
                <div
                  class="text-muted tiny-text"
                  v-if="group.multiple_select"
                >
                  <span v-if="group.min_selections==1&&group.max_selections==0">Choose a minimum of {{ group.min_selection_amount }}</span>
                  <span v-if="group.min_selections==1&&group.max_selections==1">Choose a minimum of {{ group.min_selection_amount }} and up to {{ group.max_selection_amount }}</span>
                  <span v-if="group.min_selections==0&&group.max_selections==1">Choose a up to {{ group.max_selection_amount }}</span>
                </div>
                <div
                  class="text-muted tiny-text"
                  v-else
                >Choose 1</div>

                <label>{{ group.label}}</label>
                <div
                  class="py-3 px-1 border-bottom text-muted"
                  v-for="(item,i) in group.options"
                  :key="i"
                >
                  <span v-if="group.multiple_select"> &#8414;</span>
                  <span v-else> &#9711; </span>
                  <span class="ml-2">{{ item.label }}</span> <span class="font-weight-bold">{{ rawMenu.user.currency.symbol }}{{ item.amount | centsToDollars}}</span>
                </div>
                <div class="mt-4"> <a
                    href=""
                    class="ml-3 small color-1"
                    v-on:click.prevent="removeGroup(group)"
                  >Remove</a></div>
              </div>
            </draggable>
          </div>
        </div>

        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="crossSellAccordionIsOpen=!crossSellAccordionIsOpen"
          :class="{open: crossSellAccordionIsOpen}"
        >
          <span>Cross sells</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>
        <div
          v-if="crossSellAccordionIsOpen"
          class="form-group animate__animated animate__fadeIn"
        >

          <div class="form-group p-3 bg-light rounded border shadow-sm">
            <div class="my-4 bg-white p-3">
              <label class="d-block text-center">Select cross sell groups</label>
              <hr>
              <div :class="{'items-container':crossSellGroups.length}">
                <draggable v-model="crossSellGroups">
                  <div
                    class="py-3 px-1 border-bottom"
                    v-for="(group,index) in crossSellGroups"
                    :key="'gp'+index"
                  >
                    <label class="container-label">

                      <span class="text-muted w-50">{{ group.label }}</span>

                      <input
                        v-model="group.selected"
                        type="checkbox"
                      />

                    </label>
                  </div>
                </draggable>
              </div>
              <div
                v-if="!crossSellGroups.length"
                class="text-info small text-center p-3 rounded border border-info d-flex align-items-center justify-content-center"
              > Add some cross sell groups to get started</div>
              <div>
                <a
                  class="d-inline-block mt-3"
                  :href="'/' + rawMenu.user.slug + '/menu/cross-sell-groups'"
                >
                  Cross sell manager <i class="fal fa-arrow-right ml-2"></i>
                </a>
              </div>
            </div>
          </div>

        </div>

        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="dietaryFilterAccordionIsOpen=!dietaryFilterAccordionIsOpen"
          :class="{open: dietaryFilterAccordionIsOpen}"
        >
          <span> Dietary filters</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>
        <div
          v-if="dietaryFilterAccordionIsOpen"
          class="form-group animate__animated animate__fadeIn"
        >

          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="vegetarian"
            ><span class="w-50"><i class="fal fa-carrot"></i> Vegetarian</span>
              <input
                v-model="isVegetarian"
                type="checkbox"
                id="vegetarian"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="vegan"
            ><span class="w-50"><i class="fal fa-seedling"></i> Vegan</span>
              <input
                v-model="isVegan"
                type="checkbox"
                id="vegan"
                true-value="1"
                false-value="0"
              />
            </label>

          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="gluten"
            ><span class="w-50"><i class="fal fa-wheat"></i> Gluten Free</span>
              <input
                v-model="isGlutenFree"
                type="checkbox"
                id="gluten"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="dairy"
            ><span class="w-50"><i class="fal fa-cow"></i> Dairy Free</span>
              <input
                v-model="isDairyFree"
                type="checkbox"
                id="dairy"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="nut"
            ><span class="w-50"><i class="fal fa-acorn"></i> Nut Free</span>
              <input
                v-model="isNutFree"
                type="checkbox"
                id="nut"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
        </div>
        <h4
          class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 cursor-pointer d-flex justify-content-between align-items-center accordion-toggle"
          v-on:click="timeSlotAccordionIsopen=!timeSlotAccordionIsopen"
          :class="{open: timeSlotAccordionIsopen}"
        >
          <span> Time slots</span> <i class="fal fa-chevron-down animated-chevron "></i>
        </h4>
        <div
          v-if="timeSlotAccordionIsopen"
          class="form-group animate__animated animate__fadeIn"
        >
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="timerestricted"
            ><span class="w-75">Only show at certain times</span>
              <input
                v-model="isTimeRestricted"
                type="checkbox"
                id="timerestricted"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
        </div>
        <p
          class="small text-muted"
          v-if="isTimeRestricted == 1"
        >
          If you use this feature, make sure you have selected your timezone
          in your
          <router-link
            class="color-2"
            :to="{
                name: 'userSettings',
              }"
          >settings</router-link>.
        </p>
        <div
          class="form-group"
          v-if="isTimeRestricted == 1"
        >
          <label for="time_from">From</label>
          <div>
            <vue-timepicker
              v-model="timeFrom"
              id="time_from"
              input-class="form-control"
              format="h:mm a"
            ></vue-timepicker>
          </div>
          <label for="time_to">To</label>
          <div>
            <vue-timepicker
              v-model="timeTo"
              id="time_to"
              input-class="form-control"
              format="h:mm a"
            ></vue-timepicker>
          </div>
        </div>

        <div class="py-2 my-5 border-top border-bottom">
          <div class="d-flex align-items-center justify-content-between">
            <label class="h4 p-0 m-0">Publish</label>

            <toggle-button
              v-model="isPublished"
              :sync="true"
              :color="{checked: user.menu_highlight_color}"
              :height="30"
              class="m-0"
            />
          </div>
        </div>
        <formSubmit v-if="!processing" />
      </div>
      <div
        v-if="processing"
        class="text-center my-5"
      >
        <formLoader
          v-if="processing"
          class="mb-2"
          :width="30"
        ></formLoader>
        <div
          v-if="image"
          class="small text-muted"
        >
          <div v-if="uploadPercentage < 100">
            uploading {{ uploadPercentage }}%
          </div>
          <div v-else>Processing</div>
        </div>
      </div>
    </form>
  </modal>
</template>

<style scoped>
.items-container {
  height: 15rem;
  overflow-y: scroll;
}
</style>

<script>
import modal from "../../shared/Modal";
import accountingMixin from "../../../mixins/accountingMixin";
import formMixin from "../../../mixins/formMixin";
import formLoader from "../../form/FormLoader";
import formSubmit from "../../form/FormSubmit";
import draggable from "vuedraggable";
import moment from "moment-timezone";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { ToggleButton } from "vue-js-toggle-button";
export default {
  mounted() {
    this.processing = true;
    this.getMenu(this.$route.params.userSlug).then((result) => {
      this.options = _.cloneDeep(this.rawMenu.item_options);
      _.forEach(this.options, function (cValue, cKey) {
        cValue.selected = false;
      });

      this.groupOptions = _.cloneDeep(this.rawMenu.item_options);
      _.forEach(this.groupOptions, function (cValue, cKey) {
        cValue.selected = false;
      });

      this.crossSellGroups = _.cloneDeep(this.rawMenu.cross_sell_groups);
      _.forEach(this.crossSellGroups, function (crValue, crKey) {
        crValue.selected = false;
      });

      this.processing = false;
    });
  },
  data() {
    return {
      name: null,
      category: null,
      price: null,
      priceLabel: null,
      prices: [],
      options: [],
      groupOptions: [],
      optionGroups: [],
      crossSellGroups: [],
      optionGroupMultipleSelect: 0,
      optionGroupIsRequired: 0,
      optionGroupMinSelected: 0,
      optionGroupMinSelectedAmount: 0,
      optionGroupMaxSelected: 0,
      optionGroupMaxSelectedAmount: 0,
      optionGroupLabel: null,
      optionGroupErrorMessage: null,
      description: "",
      isSpecial: 0,
      isGlutenFree: 0,
      isDairyFree: 0,
      isNutFree: 0,
      isVegan: 0,
      isVegetarian: 0,
      isTakeOut: 1,
      isTimeRestricted: 0,
      timeFrom: {
        h: "12",
        mm: "00",
        a: "am",
      },
      timeTo: {
        h: "12",
        mm: "00",
        a: "am",
      },
      isSoldOut: 0,
      isNew: 0,
      isPopular: 0,
      image: "",
      processing: false,
      uploadPercentage: 0,
      isPublished: true,
      additionalInfoAccordionIsOpen: false,
      singleAddOnAccordionIsOpen: false,
      groupedAddOnAccordionIsOpen: false,
      crossSellAccordionIsOpen: false,
      dietaryFilterAccordionIsOpen: false,
      timeSlotAccordionIsopen: false,
      taxRatesAccordionIsOpen: false,
      taxProductType: 0,
      taxAppicationOptions: [
        { text: "Default tax rate", value: 0 },
        { text: "Prepared food", value: 1 },
        { text: "Clothing", value: 2 },
      ],
    };
  },
  methods: {
    onSubmit: function () {
      this.processing = true;
      let formData = new FormData();
      let timeFrom = moment
        .utc(
          this.timeFrom.h + ":" + this.timeFrom.mm + ":00 " + this.timeFrom.a,
          "h:mm:ss a"
        )
        .format("HH:mm:ss");
      let timeTo = moment
        .utc(
          this.timeTo.h + ":" + this.timeTo.mm + ":00 " + this.timeTo.a,
          "h:mm:ss a"
        )
        .format("HH:mm:ss");

      let selectedOptions = _.filter(this.options, function (o) {
        return o.selected;
      });

      let selectedCrossSellGroups = _.filter(
        this.crossSellGroups,
        function (o) {
          return o.selected;
        }
      );

      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("category", this.category);
      formData.append("prices", JSON.stringify(this.prices));
      formData.append("options", JSON.stringify(selectedOptions));
      formData.append("option_groups", JSON.stringify(this.optionGroups));
      formData.append(
        "cross_sell_groups",
        JSON.stringify(selectedCrossSellGroups)
      );
      formData.append("is_special", this.isSpecial);
      formData.append("is_gluten_free", this.isGlutenFree);
      formData.append("is_dairy_free", this.isDairyFree);
      formData.append("is_nut_free", this.isNutFree);
      formData.append("is_vegan", this.isVegan);
      formData.append("is_vegetarian", this.isVegetarian);
      formData.append("is_take_out", this.isTakeOut);
      formData.append("is_sold_out", this.isSoldOut);
      formData.append("is_new", this.isNew);
      formData.append("is_popular", this.isPopular);
      formData.append("is_time_restricted", this.isTimeRestricted);
      formData.append("time_from", timeFrom);
      formData.append("time_to", timeTo);
      formData.append("image", this.image);
      formData.append("product_type_tax_id", this.taxProductType);

      let is_published_int;
      if (this.isPublished == true) {
        is_published_int = 1;
      } else {
        is_published_int = 0;
      }
      formData.append("is_published", is_published_int);

      axios
        .post("/api/" + this.$route.params.userSlug + "/menu/items", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        })
        .then(
          (response) => {
            this.processing = false;

            if (response.data.id) {
              this.refreshMenu(this.$route.params.userSlug);
              this.closeModals();
            }
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
    imageChanged: function (event) {
      this.image = event.target.files[0];
    },
    addPrice: function () {
      if (this.price) {
        this.prices.push({
          amount: parseFloat(this.price) * 100,
          label: this.priceLabel,
        });
        this.price = null;
        this.priceLabel = "";
      }
    },
    removePrice: function (price) {
      this.prices.splice(this.prices.indexOf(price), 1);
    },
    addOptionGroup: function () {
      this.optionGroupErrorMessage = "";
      let selectedOptions = _.filter(this.groupOptions, function (o) {
        return o.selected === true;
      });

      if (!this.optionGroupLabel) {
        this.optionGroupErrorMessage = "Add a label for the group";
        return;
      }
      //option rules
      if (this.optionGroupMultipleSelect == 1) {
        if (this.optionGroupMinSelected == 1) {
          if (this.optionGroupMinSelectedAmount < 1) {
            this.optionGroupErrorMessage =
              "Enter a minimum selected amount greater than 0";
            return;
          }

          if (this.optionGroupMaxSelected == 1) {
            if (
              this.optionGroupMaxSelectedAmount <
              this.optionGroupMinSelectedAmount
            ) {
              this.optionGroupErrorMessage =
                "Maximum selected should be greater than minimum selected";
              return;
            }
          }
        }
        if (this.optionGroupMaxSelected == 1) {
          if (this.optionGroupMaxSelectedAmount < 1) {
            this.optionGroupErrorMessage =
              "Enter a maximum selected amount greater than 0";
            return;
          }
        }
      }

      // selected option rules
      if (selectedOptions.length < 2) {
        this.optionGroupErrorMessage = "Select two options or more";
        return;
      }

      if (this.optionGroupMultipleSelect == 1) {
        if (this.optionGroupMinSelected == 1) {
          if (selectedOptions.length < this.optionGroupMinSelectedAmount) {
            this.optionGroupErrorMessage = this.optionGroupErrorMessage =
              "Select" +
              " " +
              this.optionGroupMinSelectedAmount +
              " options or more";
            return;
          }
        }
      }

      this.optionGroups.push({
        multiple_select: this.optionGroupMultipleSelect,
        is_required: this.optionGroupIsRequired,
        min_selections: this.optionGroupMinSelected,
        min_selection_amount: this.optionGroupMinSelectedAmount,
        max_selections: this.optionGroupMaxSelected,
        max_selection_amount: this.optionGroupMaxSelectedAmount,
        label: this.optionGroupLabel,
        options: selectedOptions,
      });

      this.optionGroupMultipleSelect = 0;
      this.optionGroupIsRequired = 0;
      this.optionGroupMinSelected = 0;
      this.optionGroupMinSelectedAmount = 0;
      this.optionGroupMaxSelected = 0;
      this.optionGroupMaxSelectedAmount = 0;
      this.optionGroupLabel = null;

      _.forEach(this.groupOptions, function (cValue, cKey) {
        cValue.selected = 0;
      });
    },
    removeGroup: function (group) {
      this.optionGroups.splice(this.optionGroups.indexOf(group), 1);
    },
  },
  components: {
    draggable,
    moment,
    VueTimepicker,
    formLoader,
    formSubmit,
    modal,
    ToggleButton,
  },
  mixins: [accountingMixin],
};
</script>
